module.exports = __webpack_public_path__ + "img/wl.4679703a.png";